import { render, staticRenderFns } from "./DealBannerHeader.vue?vue&type=template&id=298fc4e9&scoped=true&"
import script from "./DealBannerHeader.vue?vue&type=script&lang=js&"
export * from "./DealBannerHeader.vue?vue&type=script&lang=js&"
import style0 from "./DealBannerHeader.vue?vue&type=style&index=0&id=298fc4e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298fc4e9",
  null
  
)

export default component.exports